import { createTheme } from '@material-ui/core/styles';
import { merge, isEmpty } from 'lodash';

import { colorBlue1, colorBlue4, colorGrey1, colorGrey5 } from './../../../../../scss/_colors.scss';

const themeOverrides = {
    overrides: {
        MuiPaper: {
            root: {
                width:'99%',
                margin: '0 auto',
                boxShadow: 'none !important',
            }
        },
        MuiTable: {
            root: {
                width: '97%',
                margin: '0 auto',
                borderBottom: 'none !important',
            }
        },
        MuiTableBody: {
            root: {
                '& > tr:first-child' : {
                    paddingTop: '0px !important',
                    paddingBottom: '0px !important',
                },
            },
        },
        MuiTableCell: {
            head: {
                zIndex: '0 !important',
                color: colorGrey1,
                fontWeight: '500',
                letterSpacing: '0.1mm',
                fontSize: '16px',
                paddingTop: '0px !important',
                paddingBottom: '0px !important',
            },
            root : {
                paddingTop: '0px !important',
                paddingBottom: '0px !important',
                borderBottom: 'none !important',
                height: '48px',
                lineHeight: '1',
            },
        },
        MuiTableRow: {
            root: {
                '& > td:last-child' : {
                    '& > a:last-child' : {
                        visibility: 'hidden',
                    },
                    '& > button:last-child' : {
                        visibility: 'hidden',
                    },
                },
            },
            hover: {
                '&:hover': {
                    backgroundColor: `${colorBlue4} !important`,
                    '& > td:last-child' : {
                        color: 'blue',
                        '& > a:last-child' : {
                            visibility: 'visible',
                        },
                        '& > button:last-child' : {
                            visibility: 'visible',
                        }
                    },
                }
            },
        },
        MuiTablePagination: {
            root: {
                overflowY: 'hidden !important',
            },
        },
        MuiInputBase: {
            root: {
                '&::before': {
                    borderBottom: 'none !important',
                },
                '&::after': {
                    borderBottom: 'none !important',
                },
                backgroundColor: colorGrey5,
                padding: '4px !important',
            },
            input : {
                color : 'black !important',
                '&::placeholder': {
                    opacity: '1',
                    color : 'black !important',
                }
            }
        },
        MuiPopover: {
            paper: {
                backgroundColor: '#F4F5F7',
            },
        },
        MuiCheckbox: {
            colorSecondary: {
                '&.Mui-checked': {color: colorBlue1}
            },
        },
        MuiFormControl: {
            root: {
                width: '100%'
            }
        },
        MuiSvgIcon: {
            root: {
                color: colorBlue1
            },
        },
    }
};

export const theme = createTheme(themeOverrides);

export const customTheme = (overrides) => {
    if (isEmpty(overrides)) return theme;

    const mergeOverrides = merge({}, themeOverrides, { overrides });
    return createTheme(mergeOverrides);
};
